import { useTranslation } from "react-i18next";
import logo from "../../../assets/logo.png";
import arroz from "../../../assets/arroz.png";
import macarrao from "../../../assets/macarrao.png";
import torta from "../../../assets/torta.png";

export default function Salgadas() {
  const { t } = useTranslation();

  return (
    <section id="receitas_salgadas" className="receitas section_inicial">
      <div className="imagem-texto">
        <h1>{t("receitas.salgadas.titulo")}</h1>
        <img src={logo} alt="Logo GranCaju" />
      </div>

      <div className="receitas-container">
        <div className="receita">
          <div>
            <h2>{t("receitas.salgadas.r1.titulo")}</h2>
            <p>{t("receitas.salgadas.r1.porcao")}</p>
            <ul>
              <li>{t("receitas.salgadas.r1.ingredientes.i1")}</li>
              <li>{t("receitas.salgadas.r1.ingredientes.i2")}</li>
              <li>{t("receitas.salgadas.r1.ingredientes.i3")}</li>
            </ul>
            <p>{t("receitas.salgadas.r1.preparo")}</p>
            <p>{t("receitas.salgadas.r1.opcao")}</p>
          </div>
          <img src={arroz} alt="Imagem Arroz com Castanha-de-Caju" />
        </div>

        <div className="receita inverter">
          <img src={macarrao} alt="Imagem Macarrão com Castanha-de-Caju" />
          <div>
            <h2>{t("receitas.salgadas.r2.titulo")}</h2>
            <p>{t("receitas.salgadas.r2.porcao")}</p>
            <ul>
              <li>{t("receitas.salgadas.r2.ingredientes.i1")}</li>
              <li>{t("receitas.salgadas.r2.ingredientes.i2")}</li>
              <li>{t("receitas.salgadas.r2.ingredientes.i3")}</li>
              <li>{t("receitas.salgadas.r2.ingredientes.i4")}</li>
              <li>{t("receitas.salgadas.r2.ingredientes.i5")}</li>
              <li>{t("receitas.salgadas.r2.ingredientes.i6")}</li>
            </ul>
            <p>{t("receitas.salgadas.r2.preparo")}</p>
          </div>
        </div>

        <div className="receita">
          <div>
            <h2>{t("receitas.salgadas.r3.titulo")}</h2>
            <p>{t("receitas.salgadas.r3.porcao")}</p>
            <ul>
              <li>{t("receitas.salgadas.r3.ingredientes.i1")}</li>
              <li>{t("receitas.salgadas.r3.ingredientes.i2")}</li>
              <li>{t("receitas.salgadas.r3.ingredientes.i3")}</li>
              <li>{t("receitas.salgadas.r3.ingredientes.i4")}</li>
              <li>{t("receitas.salgadas.r3.ingredientes.i5")}</li>
              <li>{t("receitas.salgadas.r3.ingredientes.i6")}</li>
            </ul>
            <p>{t("receitas.salgadas.r3.preparo")}</p>
            <p>{t("receitas.salgadas.r3.recheio")}</p>
          </div>
          <img src={torta} alt="Imagem Torta de Castanha-de-Caju" />
        </div>
      </div>
    </section>
  );
}
